import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}, // 用户信息
    userInfo1: {}, // 榜单项目信息
    otherInfo: {} // 其他信息
  },

  getters: {
    //   getUserInfo(state) {
    //     //获取用户信息
    //     return state.userInfo;
    //   },
    //   getOtherInfo(state) {
    //     //获取其他信息
    //     return state.otherInfo;
    //   },
  },
  mutations,
  actions
})
